/*-------------------
     モジュールのimport
 ---------------------*/
import React, { PureComponent } from 'react';
/*-------------------
       materialUIのimport
   ---------------------*/
// import { connect } from 'react-redux';
import { withRouter } from 'react-router';

/**
 * フッダー作成
 */
class Footer extends PureComponent {
  /**
   * フッダー作成
   */
  render() {
    return (
      <p id="copy">
        <small>&copy; 2020 CYBERLINKS CO.,LTD.</small>
      </p>
    );
  }
}

export default withRouter(Footer);
